import { render, staticRenderFns } from "./UserDetailsOtherContactInfo.vue?vue&type=template&id=2593fc75&"
import script from "./UserDetailsOtherContactInfo.vue?vue&type=script&lang=js&"
export * from "./UserDetailsOtherContactInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports